import { Suspense } from 'react';

import { Loading } from '@/common/components';
import { Toaster } from '@/common/components/ui/sonner';
import { TooltipProvider } from '@/common/components/ui/tooltip';

import ThemeProvider from './providers/Theme';
import Jotai from './providers/Jotai';
import Query from './providers/Query';
import Router from './providers/Router';
import GlobalErrorBoundary from './GlobalErrorBoundary';
import PersistAuthGate from './PersistAuthGate';
import App from './App';

const Root = () => (
  <GlobalErrorBoundary>
    <Jotai>
      <Suspense fallback={<Loading />}>
        <ThemeProvider>
          <TooltipProvider>
            <Toaster />
            <Query>
              <PersistAuthGate loadingFallback={<Loading />}>
                <Router>
                  <App />
                </Router>
              </PersistAuthGate>
            </Query>
          </TooltipProvider>
        </ThemeProvider>
      </Suspense>
    </Jotai>
  </GlobalErrorBoundary>
);

export default Root;
